import React, { Component } from 'react';
import { Col, NavLink, Form, FormGroup, Input, Button, Nav, NavItem } from 'reactstrap';
import { connect } from 'react-redux';
import { callCardMetaDataAPI, callSetPayment, RedirectRazorPaySubmit } from 'actions/payment';
import { findObj } from 'lib/fp-utility'
import _ from "underscore";
import { DisplayPayBtnText, DisplayConvFee, DisplayConvFeeDiscription, RenderForm, GoBack, FPImages } from 'components/Common';
import GlobalLoaderModal from "components/FDModal/global-loader";
import WalletQR from "./WalletQR"

class WalletsCash extends Component {
	
	handleChange = this.handleChange.bind(this)
	handleClick = this.handleClick.bind(this)
	handlePay = this.handlePay.bind(this)
	state = { 
		selectedWallet: '' ,	
		rmsWebUrl:null,
		rmsRequestData:null,
		displayQR: false,
		qrData: {}
	}

	componentDidMount(){
		if(this.props.integrationType==='MERCHANT_PAYMENT_MODE_BANKORWALLET_INTEGRATION' && this.props.walletList){
			this.setState({ selectedWallet: this.props.walletList[0].firstPayWalletCode});	
			this.callMetaData(this.props.walletList[0]);	
		}
			
	}
	
	callMetaData = async (wallet) => {
		await this.setState({ selectedWallet: wallet, loader: true});	
		await callCardMetaDataAPI('WALLET', wallet)
		.then((resp)=>{
			if(resp.data.response.errorCode === undefined){
				this.setState({cardMetaData: resp.data.response})
			}
		})
		this.handlePay(wallet)
	}

	async handleClick(e){
		await this.setState({ selectedWallet: findObj(this.props.walletList, e, 'firstPayWalletCode') });
		callCardMetaDataAPI('WALLET', this.state.selectedWallet)
		.then((resp)=>{
			if(resp.data.response.errorCode===undefined){
				this.setState({cardMetaData: resp.data.response})
			}
		})
	}

	handleChange(e){
		if(e.target.value===''){
			this.setState({selectedWallet: '', cardMetaData: null })
			return true
		}
		// if(e.target.value === 'FPS') {
		// 	this.setState({selectedWallet: '', cardMetaData: null, displayQR : true })
		// 	return true
		// }
		const bankObj = findObj(this.props.walletList, e.target.value, 'firstPayWalletCode')
		this.setState({ selectedWallet: bankObj });
		callCardMetaDataAPI('WALLET', bankObj)
		.then((resp)=>{
			if(resp.data.response.errorCode===undefined){
				this.setState({cardMetaData: resp.data.response})
			}
		})
	}
	
	handlePay(){

		this.setState({loader: true})
		this.props.callSetPayment('WALLET', this.state.selectedWallet, this.props.txnKey, this.props.txnIv).then( resp => {
            if(resp.payload.data.paymentMethod === "WALLET_RAZOR"){
				this.setState({nbRespURL: resp.payload.data.merchantUrl})
				RedirectRazorPaySubmit(resp.payload.data.razorPayOrderResponseBean).then((getRazorPayResponse)=>{
					this.setState({razorPayRespData: getRazorPayResponse})
				})
			}else if(resp.payload.data.paymentMethod === "GRABPAY"){
				if(resp.payload.data.grabPayWebUrl){
					window.location = resp.payload.data.grabPayWebUrl;
				}else{
					this.setState({loader: false})
				}
			}
			
			else if(resp.payload.data.paymentMethod === "SBPS"){
				if(resp.payload.data.redirectUrl){
					window.location = resp.payload.data.redirectUrl;
				}else{
					this.setState({loader: false})
				}
			}
			else if(resp.payload.data.paymentMethod === "RMS"){
				this.handleRMS(resp);
			} else if(resp.payload.data.paymentMethod === "WALLET") {
				this.setState({loader: false,displayQR: true, qrData:resp.payload.data })

			}
			else{
				this.setState({loader: false})
			}
        });
	}

	handl

	handleRMS = async(resp) => {
		
		const { errorCode, errorMessage, rmsRequestData,rmsWebUrl } = resp.payload.data;
		if (rmsWebUrl && rmsRequestData && rmsRequestData.trim() != "") {
			const parsedData = JSON.parse(rmsRequestData);
			this.setState({rmsWebUrl,rmsRequestData:parsedData})
		}
			
		
    }

	formFields = () => {
		const {rmsWebUrl,rmsRequestData} = this.state;
		if(rmsRequestData){
			setTimeout(() => {
				document.RMSFORM.submit();
			}, 1000);
			return Object.entries(rmsRequestData).map(([key,value]) => {
				return <input id={key} name={key} key={key} value={value} type="hidden"></input>
	
			})
		}
		
	}


	render() {
		const { t } = this.props;
		const {rmsWebUrl,rmsRequestData} = this.state;
		const selectedWalletCode = this.state.selectedWallet && this.state.selectedWallet.firstPayWalletCode 
		const sortedWalletList =_.sortBy(this.props.walletList,'disaplyOrderId');
		return(
			<> { 
				this.state.displayQR ? <WalletQR data={this.state.qrData} t={this.props.t}/> :
				<Col xs="12">
					<div className="card-details-panel d-flex justify-content-center">
						<Form>
							<div className="list-internet-bank">
								<Nav>
									
									{this.props.walletList && sortedWalletList.slice(0,15).map((el, i) => {
										return <NavItem 
										key={el.firstPayWalletCode} 
										onClick={(e)=> {this.handleClick(el.firstPayWalletCode)}}
										className={selectedWalletCode === el.firstPayWalletCode ? 'active' : 'targetvalue'}
										>
											<NavLink style={{width:"100%",height:"100%"}}  href="#">
												<FPImages src={el.imageLoc} />
											</NavLink>
										</NavItem>})
									}
								</Nav>
							</div>   

							<FormGroup className="custom-dd">
								<Input type="select" name="select" value={selectedWalletCode} onChange={(e) => this.handleChange(e)}>
									<option value=''>
										-- Select Wallets + Cash Card --
									</option>
									{ this.props.walletList && sortedWalletList.map((el, i) => <option key={el.firstPayWalletCode} value={el.firstPayWalletCode}>{el.walletName}</option>)}
								</Input>
							</FormGroup>

							<p className="text-14 text-center mb-4">({t('click_on_pay_note')})</p>
							
							<DisplayConvFee cardMetaData={this.state.cardMetaData} t={t}/>
							<Button disabled={!this.state.selectedWallet || !this.props.termsStatus} className="btn" onClick={this.handlePay}>
								<DisplayPayBtnText cardMetaData={this.state.cardMetaData} transactionDetails={this.props.transactionDetails} t={t} />
							</Button>
							<DisplayConvFeeDiscription cardMetaData={this.state.cardMetaData} t={t}/>
							<div className="go-back-site text-center">
								<GoBack t={t} />
							</div>
						</Form>
						{rmsRequestData && 
					
					<FormGroup>
					<form action={rmsWebUrl} name='RMSFORM' method="POST">
					   {
						   this.formFields()
					   }
					</form>
				  </FormGroup>

					}
					</div>
				</Col> 
				}
				{ this.state.loader &&  <GlobalLoaderModal transaction={true} /> }
				<RenderForm className='hidden' razorPayRespData={this.state.razorPayRespData}  />
			</>
		);
	}
}

const mapStateToProps = state => {
	const {termsStatus, transactionDetails, txnKey, txnIv, globalConfig: { mConfig: { lstMerchWallet: walletList, integrationType } } } = state.fdData
	return { termsStatus,txnKey, txnIv, transactionDetails, integrationType, walletList: walletList ? walletList : [] }

}

export default connect(mapStateToProps, { callSetPayment })(WalletsCash);